import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
    .use(LanguageDetector)             // auto‐detect browser language
    .use(initReactI18next)             // pass i18n down to react‑i18next
    .init({
        fallbackLng: 'en',
        supportedLngs: ['en','kr'],      // your locales
        interpolation: { escapeValue: false },
        resources: {
            en: { translation: require('./locales/en/translation.json') },
            kr: { translation: require('./locales/kr/translation.json') }
        }
    })

export default i18n